'use client'

import Chip from '@precis-digital/kurama/Chip'
import { type ComponentProps, type ReactElement } from 'react'
import { type ThemeAssetSrc } from 'shared/assets/resolveThemeAsset'
import { useResolvedThemeAsset } from 'shared/assets/useResolvedThemeAsset'

type ChipProps = ComponentProps<typeof Chip>

type ThemedChipProps = Omit<ChipProps, 'avatarSrc'> & {
  /**
   * Same as Kurama `Chip` `avatarSrc`, or a static import under
   * `public/assets/images`. Prefer `importedAsset.src` for string-only call
   * sites. Dark mode selects the `.dark` sibling unless exempt. Remote URLs
   * pass through unchanged.
   */
  avatarSrc?: ThemeAssetSrc
}

/**
 * Drop-in theme-aware replacement for Kurama `Chip` when `avatarSrc` is set.
 * Keep `avatarSrc={img.src}` (or `avatarSrc={img}`).
 */
const ThemedChip = ({ avatarSrc, ...chipProps }: ThemedChipProps): ReactElement => {
  const resolvedAvatarSrc = useResolvedThemeAsset(avatarSrc)

  return <Chip {...chipProps} avatarSrc={resolvedAvatarSrc} />
}

export default ThemedChip
export type { ThemedChipProps }
